export const COMMON = {
  quillEditorOption: {
    theme: 'snow',
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{'header': 1}, {'header': 2}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{'direction': 'rtl'}],
        [{'size': ['small', false, 'large', 'huge']}],
        [{header: [1, 2, 3, 4, 5, 6, false]}],
        [{'color': []}, {'background': []}],
        [{'font': []}],
        [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}],
        ['clean'],
        ['link', 'image', 'video'],
        ['emoji']
      ],
      'emoji-toolbar': true,
      'emoji-shortname': true,
      'emoji-textarea': false,
      imageDrop: true,
      resize: {
        modules: ['Resize', 'DisplaySize']
      }
    }
  },
  // https://vi.wikipedia.org/wiki/Ph%C3%A2n_c%E1%BA%A5p_h%C3%A0nh_ch%C3%ADnh_Vi%E1%BB%87t_Nam
  dataSelectInitZoningCreateOrUpdate: [
    {
      key: 'provinces',
      value: 'provinceList',
      maxItem: 200,
      itemName: 'Cấp Tỉnh',
      model: 'provinceId',
      modelExt: 'province_id'
    },
    {
      key: 'districts',
      value: 'districtList',
      maxItem: 2000,
      itemName: 'Cấp Huyện',
      model: 'districtId',
      modelExt: 'district_id'
    },
    {
      key: 'communes',
      value: 'communeList',
      maxItem: 50000,
      itemName: 'Cấp Xã',
      model: 'communeId',
      modelExt: 'commune_id'
    },
    {
      key: 'divider'
    },
    {
      key: 'zoning_types',
      value: 'zoneTypeList',
      maxItem: 200,
      itemName: 'Loại quy hoạch',
      model: 'zoneTypeId',
      modelExt: 'zoning_type_Id'
    }
  ],
  toastTitleDefault: '※ Dakland',
  toastFadeTime: 5000,
  toastFadeTimeHover: 1500,
  toastShowDuration: 300,
  toastHideDuration: 500,
  codeMirror: {
    options: {
      tabSize: 4,
      mode: 'text/x-sass',
      theme: 'ayu-dark',
      lineNumbers: true,
      line: true,
      lineWrapping: true,
      styleActiveLine: true,
      styleSelectedText: true,
      showCursorWhenSelecting: true,
      readOnly: true
    },
    logData: {
      header: '/*SYSTEM_LOG_DATA*/\n-----------------------------------------------------------\n\n',
      footer: '-----------------------------------------------------------'
    }
  }
}

export const OVERLAY_VIEW = {
  MODE_DRAG: 'DRAG',
  MODE_RESIZE: 'RESIZE'
}

export const NEWS_TYPE = [
  {id: 1, name: 'Tin tức'},
  {id: 2, name: 'Bản đồ quy hoạch'}
]

export const NEWS_STATUS = [
  {id: 1, name: 'Thường', bgColor: 'info'},
  {id: 2, name: 'VIP', bgColor: 'danger'}
]

export const NEWS_APPROVAL_STATUS = [
  {id: 1, name: 'Chưa duyệt', className: 'status-pending text-dark text-custom-center'},
  {id: 2, name: 'Đã duyệt', className: 'status-success text-dark text-custom-center'},
  {id: 3, name: 'Bị cấm', className: 'status-banned text-dark text-custom-center'},
  {id: 4, name: 'Đã ẩn', className: 'status-invisible text-dark text-custom-center'}
]

export const HIGHLIGHT = [
  {id: 1, name: 'Thường'},
  {id: 2, name: 'Nổi bật'},
]

export const ITEMS_PER_PAGE = [
  {value: 10, text: 10},
  {value: 30, text: 30},
  {value: 50, text: 50},
  {value: 100, text: 100}
]

export const USER_VERIFY = [
  {id: 0, name: 'Chưa xác thực', className: 'status-pending text-dark text-custom-center'},
  {id: 1, name: 'Đã xác thực', className: 'status-success text-dark text-custom-center'},
  {id: 2, name: 'Vô hiệu hoá', className: 'status-invisible text-dark text-custom-center'}
]

export const USER_TYPE = [
  {id: 1, name: 'Thường', className: 'status-primary text-dark text-custom-center'},
  {id: 2, name: 'VIP', className: 'status-pending text-dark text-custom-center'},
  {id: 3, name: 'ADMIN', className: 'status-banned text-dark text-custom-center'}
]

export const USER_SEX = [
  {id: 1, name: 'Nam', classIcon: 'cil-user', className: 'text-custom-blue'},
  {id: 2, name: 'Nữ', classIcon: 'cil-user-female', className: 'text-custom-pink'},
  {id: 3, name: 'Khác', classIcon: 'cil-infinity', className: 'text-custom-yellow'}
]

export const COLUMN_ROW_INDEX = {
  title: 'STT',
  key: 'rowIndex',
  width: 50,
  align: 'center',
  renderBodyCell: ({rowIndex}) => {
    return ++rowIndex;
  }
}

export const COLUMN_ROW_CHECKBOX = {
  key: 'checkbox',
  type: 'checkbox',
  width: 50,
  align: 'center',
  fixed: 'left'
}

export const COLUMN_ROW_EXPAND = {
  title: '※',
  key: 'expand',
  type: 'expand',
  width: 50,
  align: 'center',
  fixed: 'left'
}

export const NEWS_TYPE_SCREEN = {
  list: {
    title: 'Tin tức',
    filter: {
      newstype: [1]
    }
  },
  map: {
    title: 'Bản đồ quy hoạch',
    filter: {
      newstype: [2]
    }
  },
  'by-user': {
    title: 'Tin quy hoạch của: ',
    filter: {
      newstype: [1, 2]
    }
  },
  'by-me': {
    title: 'Tin quy hoạch của: ',
    filter: {
      newstype: [1, 2]
    }
  }
}

export const FORM_DATA_UPDATE_USER = [
  'avatar',
  'commune_id',
  'district_id',
  'email',
  'full_name',
  'phone',
  'province_id',
  'user_sex',
  'user_type'
]

export const LOG_TEXT_LIST = [
  {id: 1, name: 'User đăng nhập thành công'},
  {id: 2, name: 'User điểm danh'},
  {id: 3, name: 'User đăng xuất'},
  {id: 4, name: 'User nạp tiền'},
  {id: 5, name: 'User đăng tin quy hoạch'},
  {id: 6, name: 'User đăng tin mua bán'},
  {id: 7, name: 'Hệ thống gửi thông báo'},
  {id: 8, name: 'User đăng ký'},
  {id: 9, name: 'User reset mật khẩu'}
]

export const LOG_TEXT_MAPPING = {
  1: {
    name: 'User đăng nhập thành công.',
    isDisplayValue: false
  },
  2: {
    name: 'User điểm danh.',
    isDisplayValue: false
  },
  3: {
    name: 'User đăng xuất.',
    isDisplayValue: false
  },
  4: {
    name: 'User nạp tiền.',
    value: '$_money:',
    isDisplayValue: true
  },
  5: {
    name: 'User đăng tin quy hoạch.',
    value: '$_view_price:',
    isDisplayValue: true
  },
  6: {
    name: 'User đăng tin mua bán.',
    value: '$_price_buy_sell:',
    isDisplayValue: true
  },
  7: {
    name: 'Hệ thống gửi thông báo.',
    isDisplayValue: true
  },
  8: {
    name: 'User đăng ký.',
    isDisplayValue: false
  },
  9: {
    name: 'User reset mật khẩu.',
    isDisplayValue: false
  }
}

export const GRAPH_API_LIST = [
  {id: 'checkin', name: 'Checkin'},
  {id: 'revenue', name: 'Revenue'},
  {id: 'like', name: 'Like'},
  {id: 'share', name: 'Share'},
]

export const GRAPH_CONFIG = {
  options: {
    maintainAspectRatio: false
  },
  dataSet: {
    default: {
      backgroundColor: 'rgba(255, 205, 86, 0.2)',
      borderColor: 'rgb(255, 205, 86)'
    },
    checkin: {
      backgroundColor: 'rgba(153, 102, 255, 0.2)',
      borderColor: 'rgb(153, 102, 255)'
    },
    revenue: {
      backgroundColor: 'rgba(75, 192, 192, 0.2)',
      borderColor: 'rgb(75, 192, 192)'
    },
    like: {
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      borderColor: 'rgb(255, 99, 132)'
    },
    share: {
      backgroundColor: 'rgba(54, 162, 235, 0.2)',
      borderColor: 'rgb(54, 162, 235)'
    }
  }
}

export const OTHER_TEXT_MAPPING = {
  province: {
    text: 'cấp tỉnh'
  },
  district: {
    text: 'cấp huyện'
  },
  commune: {
    text: 'cấp xã'
  },
  zoneType: {
    text: 'loại quy hoạch'
  },
  estateForm: {
    text: 'hình thức mua bán'
  },
  estateType: {
    text: 'Loại hình bất động sản'
  },
}
